var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { Box } from 'theme-ui';
export default function ScaleResume(_a) {
    var children = _a.children;
    var RESUME_WIDTH = 1030;
    var parentRef = useRef(null);
    var resumeRef = useRef(null);
    var _b = useState(-1), resumeHeight = _b[0], setResumeHeight = _b[1];
    var _c = useState(-1), parentWidth = _c[0], setParentWidth = _c[1];
    useEffect(function () {
        if (parentRef.current) {
            setParentWidth(parentRef.current.offsetWidth);
        }
        if (resumeRef.current) {
            setResumeHeight(resumeRef.current.offsetHeight);
        }
    }, [parentRef, resumeRef, children]);
    var scaleFactor = 1;
    // Don't set the scaleFactor if we don't have dimensions yet
    if (parentWidth !== -1) {
        scaleFactor = parentWidth / RESUME_WIDTH;
    }
    return (_jsx("div", __assign({ ref: parentRef }, { children: _jsx(Box, __assign({ sx: {
                width: RESUME_WIDTH * scaleFactor,
                height: resumeHeight * scaleFactor,
                overflow: 'hidden'
            } }, { children: _jsx(Box, __assign({ sx: {
                    transform: "scale(".concat(scaleFactor, ")"),
                    transformOrigin: 'top left'
                } }, { children: _jsx(Box, __assign({ sx: {
                        width: RESUME_WIDTH
                    }, ref: resumeRef }, { children: children }), void 0) }), void 0) }), void 0) }), void 0));
}
